import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;
const TOKEN = btoa(`${process.env.REACT_APP_API_USERNAME}:${process.env.REACT_APP_API_PASSWORD}`);

const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
    'Authorization': `Basic ${TOKEN}`
  }
});
export default api;